import { UserAccountQueryEndpoint } from '@api/endpoints/UserAccountQueryEndpoint';

type Column = UserAccountQueryEndpoint.Query.UserAccountQueryColumn;

/** Every row is one line high, so the rows in view can be worked out from the scroll position. */
export const rowHeight = 33;

// Rows rendered beyond each edge of the view, so a fast scroll doesn't show blank space.
const overscanRows = 10;

const maxColumnWidth = 360;
const textColumnWidth = 240;
// Room for the header's padding and sort arrow, and a header character's width.
const headerChromeWidth = 64;
const headerCharacterWidth = 8;

const widthByType: Record<string, number> = {
  bool: 120,
  date: 140,
  int4: 120,
  jsonb: 320,
  timestamptz: 240,
};

/** Fixed, so columns don't change width as rows scroll in and out. Long values are cut short. */
export const columnWidth = ({ name, type }: Column): number => {
  const headerWidth = name.length * headerCharacterWidth + headerChromeWidth;
  return Math.min(maxColumnWidth, Math.max(widthByType[type] ?? textColumnWidth, headerWidth));
};

/** The rows to render, `first` included and `last` not, for a view scrolled to `scrollTop`. */
export const visibleRowRange = ({
  rowCount,
  scrollTop,
  viewportHeight,
}: {
  rowCount: number,
  scrollTop: number,
  viewportHeight: number,
}): { first: number, last: number } => ({
  first: Math.max(0, Math.floor(scrollTop / rowHeight) - overscanRows),
  last: Math.min(rowCount, Math.ceil((scrollTop + viewportHeight) / rowHeight) + overscanRows),
});
